// 1977 Star Wars Allen's & Regina (New Zealand) — GENERATED by pipeline-publish (2026-06-12)
// =============================================================================
// Auto-generated from the set draft. Colors, sub-set types, ordering, and the
// SET_REGISTRY entry below are filled in. REVIEW before committing:
//   - Any placeholder color marker (a parallel name not in the standard color
//     map; the commit guard blocks until every one is resolved).
//   - Rule-7 base serial slots on numbered auto/sketch sub-sets (see in-array
//     notes; the warnings list above flags only sub-sets actually missing one).
//   - Sanity-check the auto-classified sub-set `type` and ordering.
//   - Any placeholder in the SET_REGISTRY entry below (only present if no DB
//     sets row exists for this slug, or fields are blank).
//   - A source/specimen pass on parallel names + print runs.
//   - node --check src/sets/1977-allens-regina-new-zealand.js if committing by hand, then commit + push.
//
// SET_REGISTRY entry (paste into src/setRegistry.js):
//   {
//     id: "1977-allens-regina-new-zealand",
//     name: "1977 Star Wars Allen's & Regina (New Zealand)",
//     shortName: "Allen's & Regina (New Zealand) 1977",
//     year: 1977,
//     brand: "Topps",
//     category: 'Star Wars',
//     releaseDate: "1977",
//     totalCards: 72,
//     description: "Topps 1977 Star Wars Allen's & Regina (New Zealand) trading card set.",
//     color: "#888aa0",
//     accentColor: "#f0c040",
//     dataFile: "1977-allens-regina-new-zealand",
//   },
// =============================================================================

export const SETS = [
  {
    id: "base",
    type: "base",
    title: "BASE",
    parallels: [],
    cards: [
        { n: "1", name: "Luke Skywalker" },
        { n: "2", name: "See-Threepio And Artoo-Detoo" },
        { n: "3", name: "The Little Droid, Artoo-Detoo" },
        { n: "4", name: "Space Pirate Han Solo" },
        { n: "5", name: "Princess Leia Organa" },
        { n: "6", name: "Ben (Obi-Wan) Kenobi" },
        { n: "7", name: "The Villainous Darth Vader" },
        { n: "8", name: "Grand Moff Tarkin" },
        { n: "9", name: "Rebels Defend Their Starship!" },
        { n: "10", name: "Princess Leia- Captured!" },
        { n: "11", name: "Artoo Is Imprisoned By The Jawas" },
        { n: "12", name: "The Droids Are Reunited!" },
        { n: "13", name: "A Sale On Droids!" },
        { n: "14", name: "Luke Checks Out His New Droid" },
        { n: "15", name: "Artoo-Detoo Is Left Behind!" },
        { n: "16", name: "Jawas Of Tatooine" },
        { n: "17", name: "Lord Vader Threatens Princess Leia!" },
        { n: "18", name: "Artoo-Detoo Is Missing!" },
        { n: "19", name: "Searching For The Little Droid" },
        { n: "20", name: "Hunted By The Sandpeople!" },
        { n: "21", name: "The Tusken Raiders" },
        { n: "22", name: "Rescued By Ben Kenobi" },
        { n: "23", name: "See-Threepio Is Injured!" },
        { n: "24", name: "Stormtroopers Seek The Droids!" },
        { n: "25", name: "Luke Rushes To Save His Loved Ones" },
        { n: "26", name: "A Horrified Luke Sees His Family Killed" },
        { n: "27", name: "Some Repairs For See-Threepio" },
        { n: "28", name: "Luke Agrees To Join Ben Kenobi" },
        { n: "29", name: "Stopped By Stormtroopers" },
        { n: "30", name: "Han In The Millennium Falcon" },
        { n: "31", name: "Sighting The Death Star" },
        { n: "32", name: "Lord Vader's Guards" },
        { n: "33", name: "The Droids In The Control Room" },
        { n: "34", name: "See-Threepio Diverts The Guards" },
        { n: "35", name: "Luke And Han As Stormtroopers" },
        { n: "36", name: "Blast Of The Laser Rifle!" },
        { n: "37", name: "Cornered In The Labyrinth" },
        { n: "38", name: "Luke And Han In The Refuse Room" },
        { n: "39", name: "Steel Walls Close In On Our Heroes!" },
        { n: "40", name: "Droids Rescue Their Masters!" },
        { n: "41", name: "Facing The Deadly Chasm" },
        { n: "42", name: "Stormtroopers Attack!" },
        { n: "43", name: "Luke Prepares To Swing Across The Chasm" },
        { n: "44", name: "Han And Chewie Shoot It Out!" },
        { n: "45", name: "The Light Sabre" },
        { n: "46", name: "A Desperate Moment For Ben" },
        { n: "47", name: "Luke Prepares For The Battle" },
        { n: "48", name: "Artoo-Detoo Is Loaded Aboard" },
        { n: "49", name: "The Rebels Monitor The Raid" },
        { n: "50", name: "Rebel Leaders Wonder About Their Fate!" },
        { n: "51", name: "See-Threepio And Princess Leia" },
        { n: "52", name: "Who Will Win The Final Star War?" },
        { n: "53", name: "Battle In Outer Space!" },
        { n: "54", name: "The Victors Receive Their Reward" },
        { n: "55", name: "Han, Chewie And Luke" },
        { n: "56", name: "A Day Of Rejoicing!" },
        { n: "57", name: "Mark Hamill As Luke Skywalker" },
        { n: "58", name: "Harrison Ford As Han Solo" },
        { n: "59", name: "Alec Guinness As Ben Kenobi" },
        { n: "60", name: "Peter Cushing As Grand Moff Tarkin" },
        { n: "61", name: "Mark Hamill In Control Room" },
        { n: "62", name: "Lord Vader's Stormtroopers" },
        { n: "63", name: "May The Force Be With You!" },
        { n: "64", name: "Governor Of Imperial Outlands" },
        { n: "65", name: "Carrie Fisher And Mark Hamill" },
        { n: "66", name: "Amazing Robot See-Threepio!" },
        { n: "67", name: "Lord Darth Vader" },
        { n: "68", name: "See-Threepio" },
        { n: "69", name: "Grand Moff Tarkin" },
        { n: "70", name: "Tusken Raider" },
        { n: "71", name: "Chewbacca The Wookiee" },
        { n: "72", name: "Han Solo" },
    ],
  },
];

export const ALL_CARD_KEYS = SETS.flatMap(set =>
  set.cards.map(card => `${set.id}__${card.n}`)
);

// Fallback exports used by Checklist.js for any sub-set with no inline `parallels`.
// Every sub-set above has its own inline array, so these stay empty.
export const PARALLELS = [];
export const AUTO_PARALLELS = [];
export const INSERT_PARALLELS = [];
